var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChevronUpBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.71763 9.17847L7.53962 5.2711C7.6702 5.13048 7.82589 5.06519 8.00167 5.06519C8.17745 5.06519 8.33817 5.1355 8.46875 5.2711L12.2857 9.17847C12.3962 9.28896 12.4565 9.42958 12.4565 9.59532C12.4565 9.93181 12.1953 10.193 11.8638 10.193C11.7031 10.193 11.5474 10.1327 11.4319 10.0122L8.0067 6.49152L4.57143 10.0122C4.46094 10.1277 4.30525 10.193 4.13951 10.193C3.80804 10.193 3.54688 9.93181 3.54688 9.59532C3.54688 9.43461 3.60714 9.28896 3.71763 9.17847Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevronUpBlack);
export default __webpack_public_path__ + "static/media/ic_chevron_up_black.7d1fc0cf22960722dc60a6a16d045bba.svg";
export { ForwardRef as ReactComponent };